import { Box, Button, Switch } from "@mui/material";
import React, { useState } from "react";
import NoFooterModal from "../Common/NoFooterModal";
import CommunicationHubApis from "../../services/api/CommunicationHub";
import useMutation from "../../hooks/useMutation";
import { useDispatch } from "react-redux";
import { setStatus } from "../../store/actions/User";
import useApi from "../../hooks/useApi";

const ToggleActive = ({ data, elementId, elementType, isActive, callback }) => {
  const [open, setOpen] = useState(false);
  const { mutate: updateData, isPending } = useMutation(
    CommunicationHubApis.updateElement
  );
  const dispatch = useDispatch();

  const {
    data: detailsData,
    isLoading,
    error,
  } = useApi({
    queryFn: () =>
      CommunicationHubApis.getDetail({
        element_type: elementType,
        element_id: elementId,
      }),
    initialData: {},
    enabled: open && !data,
  });

  const elementData = data ?? detailsData;
  const handleChange = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleConfirm = async () => {
    try {
      await updateData({
        ...elementData,
        is_active: !isActive,
        element_type: elementType,
      });
      callback && callback();
      setOpen(false);
    } catch (err) {
      dispatch(
        setStatus({
          message: "Something went wrong",
          type: "error",
        })
      );
    }
  };
  return (
    <>
      <Switch color="error" checked={isActive} onClick={handleChange} />
      {open && (
        <NoFooterModal
          handleClose={() => setOpen(false)}
          header
          heading={elementData?.name ?? "Are you sure?"}
        >
          {error ? (
            "Something went wrong..."
          ) : (
            <>
              <Box display={"flex"} gap={1} alignItems={"center"}>
                <img
                  src={elementData?.thumbnail?.portrait}
                  alt={elementData?.name}
                  style={{
                    height: "100%",
                    aspectRatio: "1/1",
                    maxWidth: 100,
                    borderRadius: 8,
                  }}
                />
                Are you sure you want to make it{" "}
                {!isActive ? "active" : "inactive"}?
              </Box>
              <Box mt={4} display={"flex"} justifyContent={"end"}>
                <Button
                  color="error"
                  variant="contained"
                  onClick={handleConfirm}
                  disabled={isPending || isLoading}
                >
                  Confirm
                </Button>
              </Box>
            </>
          )}
        </NoFooterModal>
      )}
    </>
  );
};

export default ToggleActive;
